import { cn } from "@/lib/utils";

/** One horizontal row (scroll); expanded shows a multi-row grid (max 5 items per row). */
export function libraryContainerGridClassName(showAll: boolean) {
  return showAll
    ? "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3"
    : "flex gap-3 overflow-x-auto pb-1 overscroll-x-contain snap-x snap-mandatory scrollbar-thin";
}

export function libraryContainerCardWrapClassName(showAll: boolean) {
  return cn(
    showAll ? "min-w-0" : "shrink-0 snap-start w-[168px] sm:w-[180px]"
  );
}

/** Show "See all" when more than this many items (won't fit one row without scroll). */
export const LIBRARY_SINGLE_ROW_SEE_ALL_THRESHOLD = 4;
